module.exports = __webpack_public_path__ + "img/image_6.19e0261f.jpg";